import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {createWellColumnGenerator} from 'contents/ProtocolEditor/VirtualTray/labwareHelper';
import {SBPlateWellsSectionContainer, SpearBioPlate} from './spearBioLabwareDefinition';

function SBSectionNormalWells({rowCount, colCount, wellStyle, labwareID, wellEventProps, wellCommonProps}) {
  const [, normalWellTemplate] = SpearBioPlate;

  const wells = useMemo(() => {
    const WellColumnGenerator = createWellColumnGenerator({
      labwareID,
      wellEventProps,
      wellCommonProps,
      wellStyle,
    });

    const wellElements = normalWellTemplate.map((ele) =>
      ele.wellSection.map((well) => {
        const {component} = WellColumnGenerator.generate(rowCount, well.index);

        return component;
      }),
    );

    return wellElements;
  }, [labwareID, normalWellTemplate, rowCount, wellCommonProps, wellEventProps, wellStyle]);

  return (
    <SBPlateWellsSectionContainer gridRowStart={9} gridRowEnd={colCount} gridColumnEnd={rowCount}>
      {wells}
    </SBPlateWellsSectionContainer>
  );
}

SBSectionNormalWells.propTypes = {
  rowCount: PropTypes.number.isRequired,
  colCount: PropTypes.number.isRequired,
  labwareID: PropTypes.string.isRequired,
  wellStyle: PropTypes.object,
  wellEventProps: PropTypes.object,
  wellCommonProps: PropTypes.object,
};

SBSectionNormalWells.defaultProps = {
  wellStyle: {},
  wellEventProps: {},
  wellCommonProps: {},
};

export default SBSectionNormalWells;
